<template>
  <v-container class="text-center">
    <v-row justify="center" align="center">
      <v-col cols="12" md="6" lg="4">
        <loading-spinner v-if="isLoading"></loading-spinner>

        <v-card v-else class="pa-5" elevation="10" rounded="lg">
          <v-card-title class="text-h5 font-weight-bold text-center">
            {{ $t('label.iskal') }}
          </v-card-title>
          <v-card-subtitle class="text-center mb-4">
            {{ $t('txt.login_description') }}
          </v-card-subtitle>

          <v-form v-model="valid">
            <v-card-text>
              <v-text-field v-model="email" :label="$t('label.email')" :rules="emailRules" @keyup.enter="handleSubmit"
                required dense outlined></v-text-field>

              <v-text-field v-model="password" :label="$t('label.password')" type="password" :rules="passwordRules"
                autocomplete="off" @keyup.enter="handleSubmit" required dense outlined></v-text-field>

              <div class="text-right">
                <span class="forgot-password-text" @click="handleForgotPassword">
                  {{ $t('txt.forgot_password') }}
                </span>
              </div>
            </v-card-text>

            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <custom-button @click="handleSubmit" :label="$t('label.login')" :disabled="!valid" color="primary"
                size="lg" gradient block></custom-button>
            </v-card-actions>

            <v-card-text>
              <p class="text-center grey--text mb-3">or</p>
              <div class="d-flex justify-center align-center">
                <v-btn icon class="social-login-btn mx-2" @click="loginWithNaver">
                  <v-img src="/img/authlogo/naver-mini.png" contain height="40" width="40"></v-img>
                </v-btn>

                <v-btn icon class="social-login-btn mx-2" @click="loginWithKakao">
                  <v-img src="/img/authlogo/kakao-mini.png" contain height="40" width="40"></v-img>
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// import LoginCard from '@/components/cards/LoginCard.vue';
import requestNaverAuthCode from '@/utils/naver';
import { authApi } from '@/api/api';
import { mapActions } from 'vuex';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

const current_domain = window.location.origin;
const kakaoRedirectUrl = `${current_domain}${process.env.VUE_APP_KAKAO_LOGIN_REDIRECT_URL}`;
const naverRedirectUrl = `${current_domain}${process.env.VUE_APP_NAVER_LOGIN_REDIRECT_URL}`;

export default {
  components: {
    // LoginCard,
    CustomButton,
    LoadingSpinner
  },
  data() {
    return {
      authProvider: null,
      alertMessage: null,
      email: '',
      password: '',
      isLoading: false,
      valid: false,
    };
  },
  methods: {
    ...mapActions('auth', ['login']),
    loginWithKakao() {
      Kakao.Auth.authorize({ redirectUri: kakaoRedirectUrl });
    },
    loginWithNaver() {
      requestNaverAuthCode(naverRedirectUrl);
    },
    async handleSubmit() {
      if (!this.email || !this.password) {
        this.notifyVue('top', 'center', this.$t('alert.invalid_form'), 'danger');
        return;
      }

      this.isLoading = true;
      const body = { email: this.email, password: this.password };

      try {
        const response = await authApi.login(body);

        if (response && response.status === 200) {
          this.login({ accessToken: response.data });
          this.$router.push({ path: '/dashboard' });
        }
      } catch (error) {
        if (error.response.status === 400 && error.response.data.code === "member_not_found") {
          this.notifyVue('top', 'center', "가입하지 않은 회원입니다.");
        } else if (error.response.status === 400 && error.response.data.code === "different_provider") {
          const message = error.response.data.message;
          this.notifyVue('top', 'center', `${message}로 가입한 계정입니다.`);
        } else if (error.response.status === 400 && error.response.data.code === "sns_registered") {
          const message = error.response.data.message;
          this.notifyVue('top', 'center', `${message}로 가입한 계정입니다.`);
        } else if (error.response.status === 400 && error.response.data.code === "invalid_password") {
          this.notifyVue('top', 'center', "잘못된 비밀번호입니다.");
        } else {
          this.notifyVue('top', 'center', this.$t('alert.failed_request'));
        }
      } finally {
        this.isLoading = false;
      }
    },
    handleForgotPassword() {
      this.$router.push({ name: "forgot-password" });
    },
    notifyVue(verticalAlign, horizontalAlign, alertMessage, alert_type) {
      this.$notify({
        timeout: 8000,
        message: alertMessage,
        icon: "priority_high",
        type: alert_type || "danger",
        horizontalAlign,
        verticalAlign,
      });
    },
  },
  computed: {
    emailRules() {
      return [
        v => !!v || this.$t('valid.required_email'),
        v => /.+@.+\..+/.test(v) || this.$t('valid.invalid_email')
      ];
    },
    passwordRules() {
      return [
        v => !!v || this.$t('valid.required_password'),
        v => v.length >= 8 || this.$t('valid.min_password')
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.forgot-password-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #1976D2;
  cursor: pointer;
  transition: 0.2s;
}

.forgot-password-text:hover {
  font-weight: 600;
  text-decoration: underline;
}

.login-button {
  font-size: 1.1rem;
  font-weight: bold;
}

.social-login-btn {
  border-radius: 50%;
  transition: 0.3s;
}

.social-login-btn:hover {
  transform: scale(1.1);
}

.v-card {
  background-color: white;
  border-radius: 12px;
}

.v-card-title {
  font-size: 1.3rem;
  font-weight: bold;
}

.v-card-subtitle {
  font-size: 1rem;
  color: #757575;
}
</style>
